var _defs, _path, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_119_2",
    width: 26.169,
    height: 30.746,
    viewBox: "0 0 26.169 30.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}.cls-3{fill:#1d8fd9}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_373",
    fill: "#1291d9",
    d: "M461.849 261.967h20.113a2.7 2.7 0 0 0 2.648-2.734v-20.264a2.7 2.7 0 0 0-2.648-2.734h-20.7a2.7 2.7 0 0 0-2.649 2.734v24.668a3.3 3.3 0 0 0 3.24 3.344H483.8a.837.837 0 0 0 0-1.673h-21.951a1.671 1.671 0 0 1 0-3.341z",
    transform: "translate(-458.609 -236.235)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_976",
    transform: "translate(8.611 6.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_374",
    d: "M473.2 246.836a4.55 4.55 0 0 1 2.512-.658 5.41 5.41 0 0 1 3.252.936 3.2 3.2 0 0 1 1.294 2.772 3.133 3.133 0 0 1-.561 1.9 6.467 6.467 0 0 1-1.261 1.2l-.613.477a1.856 1.856 0 0 0-.665.909 3.833 3.833 0 0 0-.112 1.022h-2.347a6.809 6.809 0 0 1 .276-2.022 3.568 3.568 0 0 1 1.157-1.286l.63-.493a2.226 2.226 0 0 0 .5-.511 1.744 1.744 0 0 0 .345-1.048 2.022 2.022 0 0 0-.385-1.2 1.611 1.611 0 0 0-1.4-.541 1.547 1.547 0 0 0-1.422.667 2.569 2.569 0 0 0-.419 1.385h-2.5a4.042 4.042 0 0 1 1.719-3.509zm1.438 9.735h2.59v2.5h-2.59z",
    className: "cls-2",
    transform: "translate(-471.473 -246.178)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_977",
    transform: "translate(3.131 26.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_57",
    d: "M0 0L22.703 0",
    className: "cls-2",
    transform: "translate(0.168 0.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_375",
    d: "M486.157 276.442h-22.7a.167.167 0 1 1 0-.335h22.7a.167.167 0 0 1 0 .335z",
    className: "cls-3",
    transform: "translate(-463.287 -276.107)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_978",
    transform: "translate(3.131 27.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_58",
    d: "M0 0L22.703 0",
    className: "cls-2",
    transform: "translate(0.168 0.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_376",
    d: "M486.157 278.077h-22.7a.167.167 0 1 1 0-.335h22.7a.167.167 0 1 1 0 .335z",
    className: "cls-3",
    transform: "translate(-463.287 -277.742)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenual);
export default __webpack_public_path__ + "static/media/menual.3448da22.svg";
export { ForwardRef as ReactComponent };